import { FC } from 'react';
import Grid from '@material-ui/core/Grid';
import { observer } from 'mobx-react-lite';

import { Partner } from '@constants/paymentLink';

import visaIcon from '@assets/images/partners/visa.png';
import amexIcon from '@assets/images/partners/amex.png';
import mastercardIcon from '@assets/images/partners/masterCard.png';
import useStore from '@hooks/useStore';

import { PaymentFormProps, PartnerComponent } from '../types';
import DLocalCardForm from './DLocalCardForm';
import KushkiCardForm from './KushkiCardForm';
import OpenPayCardForm from './OpenPayCardForm';
import FiservCardForm from './FiservCardForm';
import BlumonCardForm from './BlumonCardForm';
import RedPayCardForm from './RedPayCardForm';
import StripeCardForm from './StripeCardForm';
import useStyles from './styles';

export const getPartner = (partner: Partner): PartnerComponent => {
  switch (partner) {
    case Partner.OPENPAY:
      return OpenPayCardForm;
    case Partner.DLOCAL:
      return DLocalCardForm;
    case Partner.FISERV:
      return FiservCardForm;
    case Partner.BLUMON:
      return BlumonCardForm;
    case Partner.REDPAY:
      return RedPayCardForm;
    case Partner.STRIPE:
      return StripeCardForm;
    case Partner.KUSHKI:
    default:
      return KushkiCardForm;
  }
};

const getBrands = (partner: Partner, css: any) => {
  switch (partner) {
    case Partner.OPENPAY:
      return (
        <Grid item xs={12} className={`${css.brands} card-brands`}>
          <img src={visaIcon} alt="" className="brand visa" />
          <img src={mastercardIcon} alt="" className="brand mastercard" />
          <img src={amexIcon} alt="" className="brand amex" />
        </Grid>
      );
    default:
      return (
        <Grid item xs={12} className={`${css.brands} card-brands`}>
          <img src={visaIcon} alt="" className="brand visa" />
          <img src={mastercardIcon} alt="" className="brand mastercard" />
        </Grid>
      );
  }
};

const CardPaymentForm: FC<PaymentFormProps> = ({ onValidationError }) => {
  const {
    links: {
      paymentConfig: {
        paymentMethods: { card },
      },
    },
  } = useStore();
  const css = useStyles();
  const PartnerForm = getPartner(card.partner as Partner);

  return (
    <div role="tab-panel" className="tab-content card-content" data-testid="card-info-panel">
      {getBrands(card.partner as Partner, css)}
      <PartnerForm onValidationError={onValidationError} apiKey={card.publicApiKey} />
    </div>
  );
};

export default observer(CardPaymentForm);
